import md5 from 'blueimp-md5'

import { generateActions } from '../../utils'
import { API_CONST } from '../../middlewares/api'
import { handleActions, createAction } from 'redux-actions'

const initial = {
  images: []
}

const uploadImageActions = generateActions('profile/image/UPLOAD')

export const uploadImage = createAction(
  API_CONST,
  (file, onUploadProgress) => ({
    file,
    method: 'POST',
    actions: uploadImageActions,
    url: `auth/uploadImage`,
    options: { onUploadProgress }
  })
)

export const clearImges = createAction('profile/image/CLEAR')






// WEBPACK FOOTER //
// ./src/store/reducers/profile/uploadImage.js